import { debounce } from './_debounce';

/**
 * Init for module
 */
const init = () => {

	// If no card content, bail.
	if ( !document.querySelector( '.msr-faceted-search__results .card--news-and-awards' ) ) {
		return;
	}

	// Run setup.
	setup();

	// Handle window resize which changes content size.
	window.addEventListener( 'resize', debounce( setup, 200 ) );

	// Handle Faceted Search updates.
	// https://stackoverflow.com/a/41825103
	const { pushState } = history;
	history.pushState = function() {
		pushState.apply( history, arguments );
		setup();
	};
};

/**
 * Setup
 */
const setup = () => {
	// Get all available content.
	const allContent = document.querySelectorAll( '.card--news-and-awards .card__content' );

	// Stop setup if there's no content.
	if ( 0 === allContent.length ) {
		return;
	}

	processCollapsedContent();
	processExpandedContent();

	Array.prototype.forEach.call( allContent, content => {
		if ( content.classList.contains( 'card__content--expanded' ) ) {
			keepExpanded( content );
		} else {
			collapseContent( content );
		}
	} );
};

/**
 * Process already collapsed content
 */
const processCollapsedContent = () => {
	// Check to see if we've already ran and there's collapsed content on the page.
	const collapsedContent = document.querySelectorAll( '.card--news-and-awards .card__content--collapsed' );

	// If there's collapsed content, uncollapse so we can get the new height.
	if ( 0 < collapsedContent.length ) {
		Array.prototype.forEach.call( collapsedContent, content => {
			content.classList.remove( 'card__content--collapsed' );
			content.style.maxHeight = '';
		} );
	}
};

/**
 * Process already expanded content
 */
const processExpandedContent = () => {
	// Check to see if we've already ran and there's expanded content on the page.
	const expandedContent = document.querySelectorAll( '.card--news-and-awards .card__content--expanded' );

	// If there's expanded content, leave the class but reset maxHeight so we can get the new height.
	if ( 0 < expandedContent.length ) {
		Array.prototype.forEach.call( expandedContent, content => {
			content.style.maxHeight = '';
		} );
	}
};

/**
 * Content to collapse
 */
const collapseContent = ( content ) => {
	const contentHeight = content.offsetHeight;
	content.setAttribute( 'data-height', contentHeight );

	// Only collapse if there's enough content. Different browsers have slightly different heights here. 90 seems a good number to determine there's definitely another line.
	if ( 90 < contentHeight ) {
		content.classList.add( 'card__content--collapsed' );
		createExpandButton( content );
	}
};

/**
 * Content to keep expanded
 */
const keepExpanded = ( content ) => {
	const contentHeight = content.offsetHeight;
	content.setAttribute( 'data-height', contentHeight );
	content.style.maxHeight = `${contentHeight / 16}rem`;

	// If the content width doesn't need to collapse anymore.
	if ( 90 >= contentHeight ) {
		content.classList.remove( 'card__content--expanded' );
		content.style.maxHeight = '';
		content.nextSibling.outerHTML = ''; // Remove button.
	}
};

/**
 * Creates the Expand button
 * We create this each time so we don't end up with duplicate event listeners.
 */
const createExpandButton = ( content ) => {
	const button = document.createElement( 'button' );
	const contentId = content.getAttribute( 'id' );

	// Button attributes.
	button.classList.add( 'card__expand-button' );
	button.classList.add( 'button' );
	button.classList.add( 'button--text' );
	button.setAttribute( 'type', 'button' );
	button.setAttribute( 'aria-controls', contentId );
	button.setAttribute( 'aria-expanded', false );
	button.textContent = 'Expand Summary';

	// Listener.
	button.addEventListener( 'click', () => onExpandButtonClick( content, event ) );

	content.parentNode.insertBefore( button, content.nextSibling ); // Inserts button after content.
};

/**
 * Expand button click handler
 */
const onExpandButtonClick = ( content, event ) => {
	const button = event.target;
	const buttonText = button.textContent;
	const height = content.getAttribute( 'data-height' );

	// Set attributes and styles.
	button.setAttribute( 'aria-expanded', true );
	if ( 'Expand Summary' === buttonText ) {
		button.textContent = 'Collapse Summary';
		content.classList.remove( 'card__content--collapsed' );
		content.classList.add( 'card__content--expanded' );
		content.style.maxHeight = `${height / 16}rem`;
	} else {
		button.textContent = 'Expand Summary';
		content.classList.add( 'card__content--collapsed' );
		content.classList.remove( 'card__content--expanded' );
		content.style.maxHeight = '';
	}
};

// Export
export default init;
